import { styled } from '@mui/system';
import { Link, Typography } from '@mui/material';

export const LinkStyled = styled(Link)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.625rem'
});

export const TypographyStyledWhite = styled(Typography)(({ theme }) => ({
  color: theme?.palette?.common?.white,
  fontWeight: 450,
  fontFamily: 'BGRegular',
  '&:hover': { cursor: 'pointer' }
}));
